import { Fragment } from "react";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";

const About = () => {
  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="marca-hero">
        <div className="container">
          <div className="marca-hero-content">
            <h1 className="marca-hero-title">Nuestra Marca</h1>
            <p className="marca-hero-subtitle">
              Especialistas en amortiguadores y componentes de suspensión y
              dirección
            </p>
          </div>
        </div>
      </div>

      {/* Sección Principal */}
      <div className="marca-section">
        <div className="container">
          {/* Sección Introducción */}
          <div className="marca-intro">
            <h2 className="marca-section-title">¿Qué es GROB?</h2>
            <p className="marca-paragraph">
              GROB es una marca especializada en la fabricación y distribución
              de amortiguadores y componentes para la suspensión y dirección,
              diseñada para satisfacer las necesidades del mercado de repuesto
              automotriz.
            </p>
            <p className="marca-paragraph">
              GROB es reconocida por su calidad, durabilidad y precisión
              técnica y por ofrecer soluciones confiables tanto para vehículos
              de uso personal como comercial, adaptándose a las condiciones
              más desafiantes de manejo en México.
            </p>
          </div>

          {/* Estadísticas Destacadas */}
          <div className="marca-stats">
            <div className="marca-stat-item">
              <div className="marca-stat-icon">
                <i className="fa-solid fa-shield-halved"></i>
              </div>
              <div className="marca-stat-content">
                <span className="marca-stat-label">Garantía</span>
                <span className="marca-stat-value">DE POR VIDA</span>
              </div>
            </div>
            <div className="marca-stat-item">
              <div className="marca-stat-icon">
                <i className="fa-solid fa-car"></i>
              </div>
              <div className="marca-stat-content">
                <span className="marca-stat-label">Cobertura</span>
                <span className="marca-stat-value">95%</span>
              </div>
            </div>
            <div className="marca-stat-item">
              <div className="marca-stat-icon">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <div className="marca-stat-content">
                <span className="marca-stat-label">Distribución</span>
                <span className="marca-stat-value">NACIONAL</span>
              </div>
            </div>
          </div>

          {/* Sección de Garantía */}
          <div className="marca-guarantee">
            <div className="marca-guarantee-icon">
              <i className="fa-solid fa-certificate"></i>
            </div>
            <div className="marca-guarantee-content">
              <h3 className="marca-guarantee-title">Garantía de Por Vida</h3>
              <p className="marca-guarantee-text">
                GROB es la marca que ofrece <strong>"GARANTÍA DE POR VIDA"</strong> en
                amortiguadores contra cualquier falla de calidad en material o
                manufactura, gracias a los altos estándares tecnológicos con los
                que cumple en su producción.
              </p>
            </div>
          </div>

          {/* Compromiso */}
          <div className="marca-commitment">
            <div className="marca-commitment-item">
              <i className="fa-solid fa-bullseye"></i>
              <p>
                GROB se ha impuesto el compromiso de desarrollar amortiguadores
                y componentes de dirección y suspensión, para mantener el 95%
                mínimo de cobertura para el parque vehicular mexicano.
              </p>
            </div>
            <div className="marca-commitment-item">
              <i className="fa-solid fa-headset"></i>
              <p>
                GROB cuenta con una red de distribuidores capacitados para
                ofrecer soporte técnico y asesoramiento en todo el país.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default About;
